import React from 'react';
import TFFlamingo from '../../assets/TF-sun-icon.png';
import './MessageDisplay.css';

function MessageDisplay({ message, loading }) {
  return (
    <div className={`message-display ${loading ? 'loading' : ''}`}>
      <div className="robot-container">
        <img 
          src={TFFlamingo} 
          alt="TravelFind Assistant" 
          className="message-logo"
        />
      </div>
      <p className="message-text">{message}</p>
    </div>
  );
}

export default MessageDisplay; 